import { useRidesSettings } from '@/lib/settings';

/**
 * Beta banner: one slim line under the header while settings.betaMode is on and betaBannerText
 * is set. The shell hides it while the confirm-your-email banner shows (one banner at a time).
 */
export function BetaBanner() {
  const { settings } = useRidesSettings();
  const text = settings.betaBannerText?.trim();
  if (!settings.betaMode || !text) return null;
  // The seed text starts with "Beta:"; the tag already says it.
  const message = text.replace(/^beta\s*[:.]\s*/i, '');
  return (
    <div className="rides-banner warn" role="note" aria-label="Beta">
      <div className="rides-banner-inner">
        <span className="tag">Beta</span>
        <span className="msg">{message.charAt(0).toUpperCase() + message.slice(1)}</span>
      </div>
    </div>
  );
}
